import React, { useEffect } from "react";
import Lottie from "lottie-react";
import coinsAnimationData from "../assets/Flixxo Coins.json";

const CoinsAnimation = ({ onComplete, startPos, endPos }) => {
  // Use fixed positioning but animate using transform
  // We need to calculate the translation vector
  const translateX = endPos.x - startPos.x;
  const translateY = endPos.y - startPos.y;

  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 1500); // Match CSS animation duration
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div
      style={{
        position: "fixed",
        top: startPos.y,
        left: startPos.x,
        // Aligns the bottom-origin Lottie animation with the button center
        transform: "translate(-50%, -90%)",
        width: "300px",
        height: "300px",
        zIndex: 500,
        pointerEvents: "none",
        // Animate the entire container moving to the destination
        animation: "moveCoins 1.5s ease-in-out forwards",
      }}
    >
      <style>{`
        @keyframes moveCoins {
          0% {
            transform: translate(-50%, -90%) translate(0, 0) scale(0.6);
            opacity: 1;
          }
          15% {
             transform: translate(-50%, -90%) translate(0, 0) scale(1.1);
             opacity: 1;
          }
          30% {
             transform: translate(-50%, -90%) translate(${translateX * 0.15}px, ${translateY * 0.15}px) scale(1);
             opacity: 1;
          }
          85% {
            transform: translate(-50%, -50%) translate(${translateX}px, ${translateY}px) scale(0.8);
            opacity: 1;
          }
          100% {
            transform: translate(-50%, -50%) translate(${translateX}px, ${translateY}px) scale(0.1);
            opacity: 0;
          }
        }
      `}</style>
      <Lottie
        animationData={coinsAnimationData}
        loop={true} // Loop while moving
        autoplay={true}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default CoinsAnimation;
